<template>
  <div
    class="flex w-full flex-col-reverse items-end space-y-0 pb-3 md:space-x-6 xl:flex-row xl:items-center xl:justify-between"
  >
    <investment-resume :investment="investment" />
    <div
      class="flex items-center justify-between space-x-3 pb-6 md:justify-end xl:pb-0"
    >
      <ontick-button
        @click.native="$emit('stop_all')"
        size="small"
        class="w-full space-x-2 uppercase md:w-36"
        color="third"
      >
        <span v-html="$icons.stop"></span>
        <span>Parar Tudo</span>
      </ontick-button>
      <ontick-button
        @click.native="$emit('archived')"
        class="relative space-x-2"
        size="small"
        color="cinza"
      >
        <span v-html="icons.removeInvestment"></span>
        <span class="hidden md:block">Arquivados</span>
        <span
          v-show="
            investment.filter((item) => item.status === 'HIDDEN').length > 0
          "
          class="circle"
          >{{
            investment.filter((item) => item.status === "HIDDEN").length
          }}</span
        >
      </ontick-button>

      <ontick-button
        @click.native="$emit('filter')"
        class="relative space-x-2"
        size="small"
        color="cinza"
      >
        <span v-html="$icons.filter"></span>
        <span class="hidden md:block">Filtrar</span>
        <span v-show="active_filters > 0" class="circle">{{
          active_filters
        }}</span>
      </ontick-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as icons from "@/app/assets/icons/investments";

export default {
  name: "menuInvestment",

  components: {
    investmentResume: () => import("./investment-resume.component.vue"),
  },

  data() {
    return {
      investmentTypeTab: "ACTIVE", // ACTIVE | HIDDEN
      icons: icons,
      select_investment_id: null,
      search: "",
      list_search: [],
      optionDefault: {
        label: this.$screen.portrait ? " " : "Ordenar",
        icon: !this.$screen.portrait ? " " : "",
      },
      optionsSelect: [
        {
          label: "Ativo A a Z",
          type: "asc",
        },
        {
          label: "Ativo Z a A",
          type: "desc",
        },
        {
          label: "Maior Lucro",
          type: "max_profit",
        },
        {
          label: "Menor Lucro",
          type: "min_profit",
        },
        {
          label: "Posição A a Z",
          type: "position_asc",
        },
        {
          label: "Posição Z a A",
          type: "position_desc",
        },
      ],
    };
  },

  props: {
    active: {
      type: Object,
    },
    investment: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters({
      active_filters: "investment/getFilterCount",
      selectedAccount: "accountTypes/getSelectedAccount",
    }),
  },

  methods: {
    ...mapActions({
      searchInvestment: "investment/searchInvestment",
      orderInvestment: "investment/orderInvestment",
    }),

    investmentsActiveAndHidden(type) {
      this.investmentTypeTab = type;
      this.$emit("active_or_hidden", type);
    },

    handleSubmit(result) {
      this.searchInvestment(result.label);
      this.$emit("exec_filter", result);
    },
    execSearch() {
      this.$emit("stop_all");
    },
    optionSelected(event) {
      this.orderInvestment(event);
      this.$emit("exec_filter");
    },
  },
};
</script>
<style lang="scss" scoped>
.btn_left {
  @apply focus:outline-none relative -ml-px inline-flex items-center rounded-r-lg px-2 py-2 text-sm font-medium focus:z-10;
}

.btn_right {
  @apply focus:outline-none relative inline-flex items-center rounded-l-lg px-2 py-2 text-sm font-medium focus:z-10;
}

.circle {
  @apply absolute top-0 right-0 -mt-2 -ml-2 block h-4 w-4 rounded-full bg-ontick-green-500 text-xs font-semibold text-ontick-graphite-500;
}
</style>
